export default __webpack_public_path__ + "static/media/List-documentation.34fe84f3.md";